import { render, staticRenderFns } from "./prdOrcamentos.vue?vue&type=template&id=808348f8&scoped=true&"
import script from "./prdOrcamentos.vue?vue&type=script&lang=js&"
export * from "./prdOrcamentos.vue?vue&type=script&lang=js&"
import style0 from "./prdOrcamentos.vue?vue&type=style&index=0&id=808348f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808348f8",
  null
  
)

export default component.exports